export const formatFileSize = (bytes) => {
  const mb = bytes / (1024 * 1024);
  if (mb >= 0.1) {
    return `${mb.toFixed(1)} MB`;
  } else {
    const kb = bytes / 1024;
    return `${kb.toFixed(1)} KB`;
  }
};
